import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/da2j923d3r93mn1k39v0";

export default function NewsletterSection() {
  const [formError, setFormError] = useState("");
  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = (data.get("phone_alt") as string) || "";
    if (honeypot.trim()) {
      setFormStatus("success");
      setFormError("");
      form.reset();
      return;
    }

    const email = (data.get("email") as string) || "";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setFormError("请输入有效的邮箱地址。");
      setFormStatus("error");
      return;
    }

    const body = new URLSearchParams();
    data.forEach((value, key) => {
      if (key !== "phone_alt") body.append(key, String(value));
    });

    try {
      setFormStatus("idle");
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const msg = (parsed?.meta as Record<string, unknown> | undefined)?.message as string | undefined;
      const detail = (parsed?.meta as Record<string, unknown> | undefined)?.detail as string | undefined;
      const code = (parsed?.code as string | undefined) || "";

      if (
        res.ok &&
        code === "OK" &&
        !responseText.toLowerCase().includes("spam") &&
        !(msg || "").toLowerCase().includes("spam") &&
        !(detail || "").toLowerCase().includes("spam")
      ) {
        setFormStatus("success");
        setFormError("");
        form.reset();
      } else {
        setFormStatus("error");
        setFormError(msg || detail || "提交失败，请稍后再试。");
      }
    } catch {
      setFormStatus("error");
      setFormError("网络异常，请稍后再试。");
    }
  };

  return (
    <section className="relative overflow-hidden bg-primary-700 py-14 md:py-20">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20orange%20swirling%20clouds%20and%20light%20streaks%20stylized%20background%2C%20dark%20moody%20with%20golden%20highlights%2C%20painterly%20abstract%20art%2C%20atmospheric%2C%20high%20detail&width=1600&height=500&seq=cta-subscribe&orientation=landscape"
          alt=""
          aria-hidden="true"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="container-x relative text-center">
        <h2 className="font-heading text-2xl font-black text-background-50 md:text-3xl">
          订阅追更提醒，好作品不再错过
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-background-100 md:text-base">
          留下邮箱，第一时间获取火影同人作品的最新更新与优质推荐，追更不迷路。
        </p>

        <form
          id="newsletter-form"
          data-readdy-form
          onSubmit={onSubmit}
          className="mx-auto mt-8 flex max-w-lg flex-col gap-3 sm:flex-row"
        >
          <label htmlFor="subscribe-email" className="sr-only">
            邮箱地址
          </label>
          <input
            id="subscribe-email"
            type="email"
            name="email"
            autoComplete="email"
            required
            placeholder="输入你的邮箱地址"
            className="flex-1 rounded-md border border-background-50/30 bg-background-50/95 px-4 py-3 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-background-50 focus:ring-2 focus:ring-background-50/40"
          />
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-mail-send-line" />
            立即订阅
          </button>
        </form>

        {formStatus === "success" && (
          <p className="mx-auto mt-4 flex items-center justify-center gap-2 rounded-md bg-background-50/15 px-4 py-2 text-sm text-background-50">
            <i className="ri-checkbox-circle-fill text-accent-500" />
            订阅成功，感谢你的关注！
          </p>
        )}
        {formStatus === "error" && (
          <p className="mx-auto mt-4 flex items-center justify-center gap-2 rounded-md bg-background-50/15 px-4 py-2 text-sm text-accent-500">
            <i className="ri-error-warning-fill" />
            {formError}
          </p>
        )}
      </div>
    </section>
  );
}